import React, { useContext } from 'react';
import { SalesforceContext, Steps, CustomerTypes } from 'src/context/salesforce-context';
import { formatPhoneNumberText, formatIDNumberText } from 'src/helpers/formatting';
import { CONSUMER_TYPE } from 'src/services/salesforce.service';
import MiniAppEvents from 'src/helpers/miniapp-events';
import TealiumEvents from 'src/helpers/tealium-events';
import './personal-information-summary.scss';

export default function PersonalInformationSummary(props) {
  const { merchant, lead, customerType } = useContext(SalesforceContext);
  const inMiniProgram = MiniAppEvents.isInMiniApp();

  return (
    <div
      className={`PersonalInformationSummary input-area-container ${
        !props.isMobile ? 'container is-fluid container-padding' : ''
      }`}
    >
      {!props.isMobile && (
        <span>
          <div className="section-top" />
          <div className="input-area-container-heading padding-bottom-25 has-text-left personal-your-solution-heading">
            <p>
              {customerType === CustomerTypes.normal && lead.consumerType === CONSUMER_TYPE.owner
                ? 'Your personal information'
                : 'Personal information'}
              <span
                className="is-pulled-right edit-button"
                onClick={() => {
                  TealiumEvents.confirmClickEditPersonalInfo(Steps.YOUR_DETAILS, customerType);
                  props.quickNavigate(Steps.YOUR_DETAILS);
                }}
                automationid="Onboarding_Create_Account_Confirm_Your_Personal_Information_Span_Edit_Navigate_To_Your_Details"
              />
            </p>
          </div>
        </span>
      )}

      <div className="spacer-quarter" />

      <div className="columns is-multiline">
        {!props.isMobile ? (
          <div className="column is-3">
            <div className="image-container centered">
              <img
                className={'selfie-image' + (inMiniProgram ? ' in-mini-app' : '')}
                src={`data:image/jpeg;base64,${merchant?.contact?.contact_photo}`}
              />
            </div>
          </div>
        ) : (
          <div className="column is-3 pos-relative">
            <div className="spacer-quarter" />
            {props.isMobile && (
              <div className="margin-left-auto">
                <span
                  className="edit-button is-pulled-right"
                  onClick={() => {
                    TealiumEvents.confirmClickEditPersonalInfo(Steps.YOUR_DETAILS, customerType);
                    props.quickNavigate(Steps.YOUR_DETAILS);
                  }}
                  automationid="Onboarding_Create_Account_Confirm_Your_Business_Information_Span_Edit_Navigate_To_Your_Business"
                />
              </div>
            )}

            <div className="image-container centered">
              <img
                className={'selfie-image' + (inMiniProgram ? ' in-mini-app' : '')}
                src={`data:image/jpeg;base64,${merchant?.contact?.contact_photo}`}
              />
            </div>
            <div className="spacer-half" />
          </div>
        )}

        <div className="column is-3">
          <div className="text-block">
            <div className="edit-container-outer">
              <div>
                <p className="sub-heading tiny-sub-heading">First name</p>
                <p className="text-body reskin_text">{merchant?.contact?.first_names}</p>
              </div>
              {/*props.isMobile && (
                <div className="margin-left-auto">
                  <span
                    className="edit-button is-pulled-right"
                    onClick={() => {
                      props.quickNavigate(Steps.YOUR_DETAILS);
                    }}
                    automationid="Onboarding_Create_Account_Confirm_Your_Business_Information_Span_Edit_Navigate_To_Your_Business"
                  />
                </div>
                  )*/}
            </div>
          </div>

          {!props.isMobile ? (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">Surname</p>
              <p className="text-body reskin_text">{merchant?.contact?.surname}</p>
            </div>
          ) : (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">Surname</p>
              <p className="text-body reskin_text">{merchant?.contact?.surname}</p>
            </div>
          )}
        </div>

        <div className="column is-3">
          {!props.isMobile ? (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">Email address </p>
              <p className="text-body reskin_text">{merchant?.contact?.email}</p>
            </div>
          ) : (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">Contact number</p>
              <p className="text-body reskin_text">
                {formatPhoneNumberText(merchant?.contact?.phone)}
              </p>
            </div>
          )}

          {!props.isMobile ? (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">
                {merchant?.contact?.id_type === 'id' ? 'ID number' : 'Passport'}{' '}
              </p>
              <p className="text-body reskin_text">
                {formatIDNumberText(merchant?.contact?.id_number)}
              </p>
            </div>
          ) : (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">Email address </p>
              <p className="text-body reskin_text">{merchant?.contact?.email}</p>
            </div>
          )}
        </div>

        <div className="column is-3">
          {!props.isMobile ? (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">Contact number</p>
              <p className="text-body reskin_text">
                {formatPhoneNumberText(merchant?.contact?.phone)}
              </p>
            </div>
          ) : (
            <div className="text-block">
              <p className="sub-heading tiny-sub-heading">
                {merchant?.contact?.id_type === 'id' ? 'ID number' : 'Passport'}{' '}
              </p>
              <p className="text-body reskin_text">
                {formatIDNumberText(merchant?.contact?.id_number)}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="spacer-quarter" />
    </div>
  );
}
